$(window).on('load', function () {
    $('.loader').fadeOut('slow');
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
});

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

$(document).ready(function () {

    $(document).on('click', '.news-page__description a', function (event) {
        event.preventDefault();
        window.open($(this).attr('href'));
    });

    let counter = 0;

    $(document).on('click', '.display_file', function () {
        $('.preview').find('iframe').attr('src', '');
        $('.preview').find('iframe').attr('src', $(this).attr('data-href'));
        $('.preview').css('display', 'block');
        $('.wrapper').css('filter', 'brightness(0.5)');
        counter = counter + 1;
    });

    $(document).on('click', function () {
        if ($('.preview').is(':visible') && counter >= 2) {
            location.reload();
            counter = 0;
        } else {
            counter = counter + 1;
        }
    });

    $(document).on('click', '.leader_click, .commitees_click', function () {
        if ($(this).attr('data-href')) {
            window.location.href = $(this).attr('data-href');
        }

        return false;
    });

    $(document).on('click', '.callback-help__button', function (event) {
        event.preventDefault();
        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                if ($('input[name="name"]').val() == '' || $('input[name="email"]').val() == '' || $('textarea[name="question"]') == '') {
                    toastr.error(fillNecesaryInfo);
                    return false;
                }

                $.ajax({
                    type: "POST",
                    url: "/feedback?token=" + token,
                    data: $('.callback-help__form').serialize(),
                    success: function () {
                        $('input[name="name"]').val('');
                        $('input[name="email"]').val('');
                        $('textarea[name="question"]').val('');
                        toastr.success(questionSent);
                    }
                });
            });
        });
        return false;
    })

    $(document).on('click', '.item-video__image', function () {
        window.location.href = $(this).attr('data-href');
    });
});